import axios from "axios";
import InfoModal from "../../../MHSSS Accounting/outstanding/PersonTransaction/Vouchers/infoModal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
import ContactInfo from "../contactInfo";
const Main = () => {
  const location = useLocation();
  const dash = location.pathname;
  const id = location?.state?.id;
  const [selectedTransactionsVouchers, setSelectedTransactionsVouchers] =
    useState(location?.state?.selectedTransactionsVouchers);
  console.log(selectedTransactionsVouchers);
  const sapMoneyEnable = useSelector((state) => state.sapMoneyEnable);
  const [email, setEmail] = useState([]);
  const [phone, setPhone] = useState([]);
  const [showContact, setShowContact] = useState(false);
  const dataUser = useSelector((state) => state.dataUser);
  const [showInfo, setShowInfo] = useState(false);
  const [voucher, setVouchers] = useState([]);
  const [content, setContent] = useState("");
  const user = useSelector((state) => state.user);

  useEffect(() => {
    const api = user === "pensioner" ? "for-pensioner" : "for-merchant";
    const tok =
      user === "pensioner"
        ? dataUser?.data?.tokens?.access?.token
        : dataUser?.data?.merchTokens?.access?.token;
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/merch-redeem-coupon/${api}?merchTransactionId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${tok}`,
          },
        }
      )
      .then((data) => {
        setVouchers(data?.data?.rows);
        data?.data?.rows?.map((item, index) => {
          imageConverter(item?.voucherImage, index);
        });
      })
      .catch(() => {
        // Handle error
      });
  }, []);

  // Get Transactions Sap Money
  useEffect(() => {
    if (
      dash === "/SapMoney/Pensioner/programTransaction/detail" ||
      dash === "/SapMoney/Pensioner/programTransaction/detail"
    ) {
      const api = user === "pensioner" ? "for-pensioner" : "for-merch";
      const tok =
        user === "pensioner"
          ? dataUser?.data?.tokens?.access?.token
          : dataUser?.data?.merchTokens?.access?.token;
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/v1/merch-transactions/${id}/details/${api}`,
          {
            headers: {
              Authorization: `Bearer ${tok}`,
            },
          }
        )
        .then((data) => {
          setSelectedTransactionsVouchers(data?.data);
        })
        .catch(() => {
          // Handle error
        });
    }
  }, []);

  const Div = ({ label, value }) => {
    return (
      <div className="flex justify-between items-center">
        <div
          className={`${
            user !== "pensioner"
              ? "text-gray-600 flex items-center text-[0.8rem]"
              : "flex items-center"
          } `}
        >
          {label}
        </div>
        <div
          className={`
          ${
            user !== "pensioner"
              ? "font-semibold flex items-center capitalize text-[0.8rem]"
              : "text-sm font-bold flex items-center capitalize"
          } `}
        >
          {value}
        </div>
      </div>
    );
  };

  const getMonthName = (month) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return monthNames[month - 1]; // Subtracting 1 since months are zero-based in JavaScript Date
  };

  const imageConverter = (url, index) => {
    const api =
      user === "pensioner"
        ? "v1/file/get-image-url?fileType=paymentRecipet"
        : "v1/file/merchat-file-presigned-url?fileType=paymentRecipet";
    const tok =
      user === "pensioner"
        ? dataUser?.data?.tokens?.access?.token
        : dataUser?.data?.merchTokens?.access?.token;
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/${api}`,
        {
          fileNames: [url],
        },
        {
          headers: {
            Authorization: `Bearer ${tok}`,
          },
        }
      )
      .then((data) => {
        setVouchers((prev) => {
          let newArr = [...prev];
          newArr[index].url = data?.data[0]?.url;
          return newArr;
        });
        // setVouchers((prev) => {
        //     let newArr = [...prev];
        //     newArr[contactIndex].merchcontactpersondocs[docIndex].images[
        //       imageIndex
        //     ] = data?.data[0]?.url;
        //     return newArr;
        //   });
      })
      .catch((err) => {
        // Handle error
      });
  };

  return (
    <div
      className={`flex flex-col w-full rounded-md flex  
    ${
      dash === "/SapMoney/Pensioner/programTransaction/detail"
        ? "sm:px-5 ipad-pro:px-2 "
        : "sm:px-8 ipad-pro:px-5"
    }
    `}
    >
      <div
        className={`flex flex-col w-full relative  bg-white  ipad-pro:gap-3  gap-4 flex 
        ${
          dash === "/SapMoney/Pensioner/programTransaction/detail"
            ? "pt-6 pb-10 p-4 px-4 ipad-pro:px-2 "
            : "pt-8 pb-10 p-4 px-6 ipad-pro:px-4 shadow-lg rounded-md"
        }
        `}
      >
        <div className="flex  sm:flex-row flex-col ">
          <div className="sm:w-1/4 bg-white rounded-md p-4 w-full  ipad-pro:p-2">
            <header className="px-2 py-4 flex flex-col justify-center items-center text-center bg-[#F4F4F4] rounded-lg">
              <img
                className={`${
                  user !== "pensioner"
                    ? "hidden"
                    : "inline-flex object-cover border-4 border-primary rounded-full  bg-primary text-indigo-600 h-24 w-24"
                }`}
                src={
                  selectedTransactionsVouchers?.merchstore !== null
                    ? selectedTransactionsVouchers?.merchstore?.image
                    : selectedTransactionsVouchers?.merchuser?.merchcompany !==
                      null
                    ? selectedTransactionsVouchers?.merchuser?.merchcompany
                        ?.logo
                    : "data:image/png;base64,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"
                }
                alt=""
              />
              <img
                className={`${
                  user !== "pensioner"
                    ? "inline-flex object-cover border-4 border-primary rounded-full  bg-primary text-indigo-600 h-24 w-24"
                    : "hidden"
                }`}
                src={
                  selectedTransactionsVouchers?.user?.person !== null
                    ? selectedTransactionsVouchers?.user?.person?.image
                    : "data:image/png;base64,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"
                }
                alt=""
              />
              <h1
                className={`
                ${
                  user === "pensioner"
                    ? "text-xl text-gray-700 font-bold mt-2"
                    : "hidden"
                }
              }`}
              >
                {selectedTransactionsVouchers?.merchstore !== null
                  ? selectedTransactionsVouchers?.merchstore?.customStoreName
                  : selectedTransactionsVouchers?.merchuser?.merchcompany?.name}
              </h1>
              <h1
                className={`${
                  user !== "pensioner"
                    ? "text-lg text-gray-700 font-bold mt-2"
                    : "hidden"
                }`}
              >
                {selectedTransactionsVouchers?.user !== null ? (
                  <>
                    {selectedTransactionsVouchers?.user?.person?.firstName
                      ? selectedTransactionsVouchers?.user?.person?.firstName
                      : "-----"}{" "}
                    {selectedTransactionsVouchers?.user?.person?.middleName
                      ? selectedTransactionsVouchers?.user?.person?.middleName
                      : ""}{" "}
                    {selectedTransactionsVouchers?.user?.person?.lastName
                      ? selectedTransactionsVouchers?.user?.person?.lastName
                      : ""}
                  </>
                ) : (
                  "------"
                )}
                <p className="text-xs text-gray-400 truncate">
                  GID:{" "}
                  {selectedTransactionsVouchers?.user?.gid
                    ? selectedTransactionsVouchers?.user?.gid
                    : "-----"}
                </p>
              </h1>

              <h2
                className={`${
                  user === "pensioner"
                    ? "text-base md:text-sm text-primary font-bold"
                    : "hidden"
                }`}
              >
                <a
                  href=""
                  target="_blank"
                  className="text-primary font-semibold border-b-0 hover:border-b-4 hover:border-b-indigo-300 transition-all mb-2"
                >
                  {selectedTransactionsVouchers?.byGovtAgency === true
                    ? "Government Agency"
                    : "Merchant"}
                </a>
              </h2>
            </header>
          </div>
          <div className="sm:w-3/4 w-full  p-5 ipad-pro:p-2 rounded-md">
            <div className="w-full bg-[#F4F4F4] p-4 ipad-pro:p-2 sm:gap-7 flex sm:flex-row flex-col h-full rounded-md gap-3">
              <div className="sm:w-[45%] flex flex-col gap-3">
                <Div
                  label="Payment Date :"
                  value={moment(selectedTransactionsVouchers?.createdAt).format(
                    "MM/DD/YYYY hh:mm A"
                  )}
                />
                <Div
                  label="Amount :"
                  value={`$${
                    selectedTransactionsVouchers?.totalAmount
                      ? selectedTransactionsVouchers?.totalAmount
                      : ""
                  }`}
                />
                <Div
                  label="Booklet # :"
                  value={`${
                    selectedTransactionsVouchers?.pensionbook?.bookletNo
                      ? selectedTransactionsVouchers?.pensionbook?.bookletNo
                      : ""
                  }${
                    selectedTransactionsVouchers?.pensionbook?.year
                      ? `(${selectedTransactionsVouchers?.pensionbook?.year})`
                      : ""
                  }`}
                />
                <Div
                  label="Program :"
                  value={
                    selectedTransactionsVouchers?.pensionbook?.pensionprogram
                      ?.name === "senior-citizen-Pension"
                      ? "Senior Citizen Pension"
                      : selectedTransactionsVouchers?.pensionbook
                          ?.pensionprogram?.name
                  }
                />
              </div>
              <div className="sm:w-[55%] flex flex-col gap-3">
                <div className="flex justify-between items-center">
                  <div
                    className={`${
                      user !== "pensioner"
                        ? "text-gray-600 flex items-center text-[0.8rem]"
                        : "mt-0"
                    }`}
                  >
                    Voucher transaction ID :{" "}
                    <span
                      onClick={() => {
                        setContent(
                          "Auto generated transaction ID when Merchant redeemed pensioner’s vouchers."
                        );
                        setShowInfo(true);
                      }}
                      className="w-4 h-4 bg-primary text-white rounded-full inline-flex items-center justify-center ml-1"
                    >
                      i
                    </span>
                  </div>
                  <div
                    className={`
          ${
            user !== "pensioner"
              ? "font-semibold flex items-center capitalize text-[0.8rem]"
              : "text-sm font-bold flex items-center capitalize"
          } `}
                  >
                    {selectedTransactionsVouchers?.transactionId}
                  </div>
                </div>

                <Div
                  label="Transaction Type :"
                  value={`${
                    voucher && voucher.length > 0 && voucher[0].paymentMethod
                      ? voucher[0].paymentMethod
                      : ""
                  }`}
                />

                <Div label="Number of Vouchers :" value={voucher?.length} />
                <div
                  className={`bg-[#1BA397] text-white px-3 p-2 flex justify-between `}
                >
                  {dataUser?.data?.merchuser?.isGovtAgency ? (
                    <p>HQ</p>
                  ) : (
                    <p>Store/HQ</p>
                  )}
                  <p>
                    {selectedTransactionsVouchers?.merchstore !== null
                      ? selectedTransactionsVouchers?.merchstore
                          ?.customStoreName
                      : selectedTransactionsVouchers?.merchuser?.merchcompany
                          ?.name}
                  </p>
                  <p
                    className={`${
                      selectedTransactionsVouchers?.merchstore === null
                        ? "hidden"
                        : "cursor-pointer"
                    }`}
                    onClick={() => {
                      setShowContact(true);
                      if (selectedTransactionsVouchers?.merchstore === null) {
                        setEmail(
                          selectedTransactionsVouchers?.merchheadquarter?.emails
                        );
                        setPhone(
                          selectedTransactionsVouchers?.merchheadquarter
                            ?.contacts
                        );
                      } else {
                        setEmail(
                          selectedTransactionsVouchers?.merchstore?.emails
                        );
                        setPhone(
                          selectedTransactionsVouchers?.merchstore?.phones
                        );
                      }
                    }}
                  >
                    View
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Vouchers */}
        {/* <div>
          <div
            className={`${
              user === "pensioner"
                ? "grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-4 p-6 cursor-pointer"
                : "grid lg:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-4 p-6 cursor-pointer"
            }`}
          >
            {voucher?.map((data, ind) => (
              <div
                key={ind}
                className="h-auto shadow-lg rounded-lg border border-[#1BA397] bg-[#F4F8F6] p-2 px-3"
              >
                <img src={data?.url} alt="" className="w-full h-32 mt-2" />

                <div className="w-full mt-1 p-2 space-y-2">
                  <Div label={"Amount :"} value={`$${data?.amountPaid}`} />
                 
                </div>
                <div className="w-full pl-2 pr-2 ">
                  <div className="flex justify-between">
                    <div className={`text-gray-600 flex items-center`}>
                      Voucher cashing ID :{" "}
                      <p
                        className="ml-1 w-[16px] h-[16px] text-center flex items-center justify-center bg-primary text-semibold text-white rounded-full cursor-pointer"
                        onClick={() => {
                          setContent(
                            "Auto generated Unique Transaction ID for each voucher cashing."
                          );
                          setShowInfo(true);
                        }}
                      >
                        i
                      </p>
                    </div>
                    <div className={`flex items-center capitalize relative`}>
                      {data?.transactionId}
                    </div>
                  </div>
                </div>

                <div className="w-full pl-2 pr-2 mt-1">
                  <div className="flex justify-between space-y-2">
                    <div className={`text-gray-600 flex items-center`}>
                      Voucher :
                    </div>
                    <div className={`flex items-center capitalize`}>
                      {getMonthName(data?.coupon?.month)}{" "}
                      {moment(data?.coupon?.year).format("YYYY")}
                    </div>
                  </div>
                </div>
                <div className="w-full pl-2 pr-2 mt-1">
                  <div className="flex justify-between space-y-2">
                    <div className={`text-gray-600 flex items-center`}>
                      Status :
                    </div>
                    <div
                      className={`flex items-center capitalize text-primary font-semibold`}
                    >
                      REDEEMED
                    </div>
                  </div>
                </div>
              
              </div>
            ))}
          </div>
        </div> */}

        <div
          className={`${
            user === "pensioner"
              ? "grid lg:grid-cols-3 ipad-pro:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-4 p-4 cursor-pointer"
              : "grid lg:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-4 p-4 cursor-pointer px-6"
          }`}
        >
          {voucher?.map((data, ind) => (
            <div
              key={ind}
              className="h-auto relative  shadow-lg rounded-xl border border-[#1BA397] bg-[#F4F8F6] p-2 px-3"
            >
              <div className="w-full pl-2 pr-2 mt-1">
                <div className="flex justify-between items-center text-[0.8rem]">
                  <div className={`text-gray-600 flex items-center`}>
                    Voucher No:
                  </div>
                  <div className={`flex items-center capitalize`}>
                    {getMonthName(data?.coupon?.month)}{" "}
                    {moment(data?.coupon?.year).format("YYYY")}
                  </div>
                </div>
              </div>
              <div className="w-full pl-2 pr-2 mt-1 ">
                <div className="flex justify-between items-center">
                  <div
                    className={`${
                      user !== "pensioner"
                        ? "text-gray-600 text-[0.8rem]"
                        : "mt-2 text-[0.8rem] text-gray-600"
                    }`}
                  >
                    Voucher cashing ID :{" "}
                    <span
                      onClick={() => {
                        setContent(
                          "Auto generated Unique Transaction ID for each voucher cashing."
                        );
                        setShowInfo(true);
                      }}
                      className="w-4 h-4 bg-primary text-white rounded-full inline-flex items-center justify-center"
                    >
                      i
                    </span>
                  </div>
                  {/* <div
              className={`
          ${
            user !== "pensioner"
              ? "font-semibold flex items-center capitalize text-[0.8rem]"
              : "text-sm font-bold flex items-center capitalize"
          } `}
            >
              {selectedTransactionsVouchers?.transactionId}
            </div> */}
                  <div className={`capitalize relative text-[0.8rem]`}>
                    {data?.transactionId}
                  </div>
                </div>
              </div>
              <div className="flex gap-6 mt-2 p-2">
                <div className="w-[70%] ipad-pro:w-[70%]">
                  <img src={data?.url} alt="" className="w-full h-26 mt-2 " />
                </div>
              </div>
              <div className="absolute  right-[10px] bottom-[10px]">
                <div className="flex justify-between flex-col">
                  <div className={`text-gray-600 flex items-center`}>
                    ${data?.amountPaid}
                  </div>
                  <div
                    className={`flex items-center capitalize text-primary font-semibold ipad-pro:text-[0.7rem]`}
                  >
                    REDEEMED
                  </div>
                </div>
              </div>
              {/* <img src={data?.url} alt="" className="w-full h-32 mt-2" /> */}
            </div>
          ))}
        </div>

        {showInfo && <InfoModal setShow={setShowInfo} content={content} />}
        {showContact && (
          <ContactInfo
            setShow={setShowContact}
            email={email}
            phone={phone}
            store={true}
            data={selectedTransactionsVouchers}
          />
        )}
      </div>
    </div>
  );
};

export default Main;
